<template>
    <div class="row">
        <div class="col-md-12">
            <div class="bilings-header">
                <h3>Billing</h3>

                <div class="ballance">
                    <em>Your balance</em>
                    <strong>$ 45</strong>
                </div>

                <div class="promo-balance">
                    <em>Promo balance</em>
                    <strong>$ 7</strong>
                </div>

                <div class="pending-charges">
                    <em>Pending charges</em>
                    <strong>$ 115</strong>
                </div>

                <div class="available-funds">
                    <em>Available Funds</em>
                    <strong>$ 1167.45</strong>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <div>Balance History</div>
                </div>
                <div class="card-body">
                    <div class="mb-0 table-outline table-responsive-sm">
                        <b-table
                            striped
                            hover
                            class="mb-0 table-outline"
                            responsive="sm"
                            :items="balanceHistory"
                            :fields="tableFields"
                        ></b-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: "billings",
    components: "",
    data: () => {
        return {
            defaultString: "string",
            balanceHistory: [
                {
                    date: "3/4/2019",
                    name: "Elixir",
                    interval: "Monthly",
                    sim: "[FTS] Johnatan Malko 24",
                    type: "Data End",
                    pre_balance: "$ 125",
                    ammount: "-$ 45",
                    balnce: "$ 80"
                },
                {
                    date: "3/4/2019",
                    name: "Elixir",
                    interval: "Monthly",
                    sim: "[FTS] Johnatan Malko 24",
                    type: "Data End",
                    pre_balance: "$ 125",
                    ammount: "-$ 45",
                    balnce: "$ 80"
                },
                {
                    date: "3/4/2019",
                    name: "Elixir",
                    interval: "Monthly",
                    sim: "[FTS] Johnatan Malko 24",
                    type: "Data End",
                    pre_balance: "$ 125",
                    ammount: "-$ 45",
                    balnce: "$ 80"
                },
                {
                    date: "3/4/2019",
                    name: "Elixir",
                    interval: "Monthly",
                    sim: "[FTS] Johnatan Malko 24",
                    type: "Data End",
                    pre_balance: "$ 125",
                    ammount: "-$ 45",
                    balnce: "$ 80"
                },
                {
                    date: "3/4/2019",
                    name: "Elixir",
                    interval: "Monthly",
                    sim: "[FTS] Johnatan Malko 24",
                    type: "Data End",
                    pre_balance: "$ 125",
                    ammount: "-$ 45",
                    balnce: "$ 80"
                },
                {
                    date: "3/4/2019",
                    name: "Elixir",
                    interval: "Monthly",
                    sim: "[FTS] Johnatan Malko 24",
                    type: "Data End",
                    pre_balance: "$ 125",
                    ammount: "-$ 45",
                    balnce: "$ 80"
                }
            ],
            tableFields: {
                date: {
                    label: "Date",
                    class: "text-left"
                },
                name: {
                    label: "Name"
                },
                interval: {
                    label: "Interval",
                    class: "text-left"
                },
                sim: {
                    label: "Sim"
                },
                type: {
                    label: "Type",
                    class: "text-left"
                },
                pre_balance: {
                    label: "Pre Balance",
                    class: "text-right color-green"
                },
                ammount: {
                    label: "Quantity",
                    class: "text-right color-red"
                },
                balnce: {
                    label: "Balance",
                    class: "text-right"
                }
                // {
                //   key: "balance",
                //   label: "Balance",
                //   variant: "danger"
                // }
            }
        };
    }
};
</script>

<style lang="scss">
.bilings-header {
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    border: 1px solid #c8ced3;
    background: #fff;
    border-radius: 0.25rem;
    h3 {
        margin: 0;
        margin-right: 20px;
        font-size: 24px;
        text-transform: uppercase;
        font-weight: 700;
    }
    > div {
        height: 35px;
        width: 15%;
        margin-right: 10px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        background: #f0f3f5;
        border-radius: 5px;
        line-height: 35px;
        em {
            font-size: 16px;
            font-style: normal;
        }
    }
}
</style>
